const prefix = '/auth';

export const ApiAuthUrls = {
  changeLocale: `${prefix}/change-locale`,
  completeRegistration: `${prefix}/complete-registration`,
  completePersonalData: `${prefix}/complete-personal-data`,
  forceLogout: `${prefix}/force-logout`,
  loginUser: `${prefix}/login`,
  logout: `${prefix}/logout`,
  setNewPassword: `${prefix}/set-password`,
  signUpUser: `${prefix}/signup`,
  verifyEmail: `${prefix}/verify-email`,
  verifyPhoneNumber: `${prefix}/verify-phone-number`,
  createVerificationCode: `${prefix}/request-verification-code`,
};
